import axios from '../axiosConfig'
import { getEnv } from '@utils/env'
import type { RangeKey } from '@dataTypes/dashboard.types'
import type { DashboardMetricItemData } from '../../../types/dashboardMetrics.types'
import type { PatientStatusDetailRow } from '../../../pages/Dashboard/PatientStatusDetail/patientStatusDetail.mockData'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_PATIENT')
const BASE = `${BUSINESS_LAYER_API}/api/v1/patient/operations/patient-status`

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

export type PatientStatusChartPoint = {
  label: string
  value: number
}

export type PatientStatusAxisConfig = {
  yAxisDomain: [number, number]
  yAxisTicks: number[]
}

export type PatientStatusOverview = {
  metrics: DashboardMetricItemData[]
  chartData: PatientStatusChartPoint[]
  axis: PatientStatusAxisConfig
}

function buildParams(range: RangeKey, date?: string): Record<string, string> {
  const params: Record<string, string> = { range }
  if (date) params.date = date
  return params
}

export const getPatientStatusOverview = (
  range: RangeKey,
  date?: string,
): Promise<PatientStatusOverview> =>
  axios
    .get<ApiResponse<{ overview: PatientStatusOverview }>>(`${BASE}/overview`, {
      params: buildParams(range, date),
    })
    .then((response) => response.data.data.overview)

export const getPatientStatusPatients = (
  range: RangeKey,
  date?: string,
): Promise<PatientStatusDetailRow[]> =>
  axios
    .get<ApiResponse<{ patients: PatientStatusDetailRow[] }>>(
      `${BASE}/patients`,
      {
        params: buildParams(range, date),
      },
    )
    .then((response) => response.data.data.patients)
